import gql from "graphql-tag";

export const createCustomerMutation = gql`
  mutation createCustomer(
    $name: String!
    $isActive: Boolean
    $storageId: ID
    $accessGroupId: ID
    $defaultCompanyId: ID
    $companies: [ID]
  ) {
    createCustomer(
      name: $name
      isActive: $isActive
      storageId: $storageId
      accessGroupId: $accessGroupId
      defaultCompanyId: $defaultCompanyId
      companies: $companies
    ) {
      id
    }
  }
`;
